import React from 'react';
import PageTitle from '../../../components/PageTitle';
import { Container, Row } from 'shards-react';

import Errors from '../../../components/Errors';
import GenericSearchBar from '../../../components/common/GenericSearchBar/GenericSearchBar';
import { Provider as LoadingProvider } from '../../../contexts/LoadingContext';
import AccountNameOrIdInput from '../../../components/inputs/AccountNameOrIdInput';
import CredentialUsernameInput from '../../../components/inputs/CredentialUsernameInput';
import CredentialStatusInput from '../../../components/inputs/CredentialStatusInput';
import RegisteredInfoProvidersInput from '../../../components/inputs/RegisteredInfoProvidersInput';
import Constants from '../../../data/Constants';
import { useCredentials } from '../../../hooks/queries/useCredentials';
import { useUrlState } from '../../../hooks/useUrlState';
import { positiveIntegerParam, stringParam } from '../../../utils/urlStateParams';
import Table from './Table';

import '../../../assets/styles/icons.css';

const inputs = [
  CredentialUsernameInput,
  AccountNameOrIdInput,
  RegisteredInfoProvidersInput,
  CredentialStatusInput
];

const URL_STATE_CONFIG = {
  accountNameOrId: stringParam(),
  credentialStatus: stringParam(),
  credentialUsername: stringParam(),
  infoProvider: stringParam(),
  page: positiveIntegerParam()
};

const List = () => {
  const [urlState, setUrlState] = useUrlState(URL_STATE_CONFIG);
  const offset = (urlState.page - 1) * Constants.elementsPerPage;
  const filter = {
    accountNameOrId: urlState.accountNameOrId || undefined,
    credentialStatus: urlState.credentialStatus || undefined,
    credentialUsername: urlState.credentialUsername || undefined,
    infoProvider: urlState.infoProvider || undefined
  };
  const { credentials, loading, error } = useCredentials(filter, {
    limit: Constants.elementsPerPage,
    offset
  });

  const onSubmit = (newFilter) => {
    setUrlState({
      accountNameOrId: newFilter.accountNameOrId?.trim() || '',
      credentialStatus: newFilter.credentialStatus || '',
      credentialUsername: newFilter.credentialUsername?.trim() || '',
      infoProvider: newFilter.infoProvider || '',
      page: 1
    });
  };

  const handlePageClick = (direction) => {
    const page = urlState.page + direction;
    if (page >= 1) setUrlState({ page });
  };

  return (
    <Container className="main-content-container px-4" fluid>
      <Row className="page-header py-4" noGutters>
        <PageTitle className="text-sm-left" sm="4" subtitle="" title="Credenciales" />
      </Row>
      <LoadingProvider value={loading}>
        <GenericSearchBar handleSubmit={onSubmit} inputs={inputs} values={urlState} />
        <Errors errors={error ? ['No se pudieron cargar las credenciales.'] : null} />
        <Table
          credentials={credentials}
          disableNext={credentials.length < Constants.elementsPerPage}
          disablePrev={urlState.page === 1}
          onPageClick={handlePageClick}
        />
      </LoadingProvider>
    </Container>
  );
};

export default List;
